import { createEnv } from "@t3-oss/env-core";
import { clientEnvSchema } from "@/shared/env";
import { parseBuildTimeBoolean } from "@/shared/env/buildTimeHelpers";

export const env = createEnv({
  onValidationError: (error) => {
    console.error(error);
    throw new Error(`Environment validation failed: ${JSON.stringify(error)}`);
  },
  /**
   * Server-side environment variables schema (empty for Vite)
   */
  server: {},

  /**
   * Client-side environment variables schema
   */
  client: clientEnvSchema,
  clientPrefix: "VITE_",

  /**
   * Runtime environment variables mapping
   */
  runtimeEnv: {
    VITE_APP_URL: import.meta.env.VITE_APP_URL,
    VITE_BE_URL: import.meta.env.VITE_BE_URL,
    VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
    VITE_GA_ID: import.meta.env.VITE_GA_ID,
    VITE_YM_ID: import.meta.env.VITE_YM_ID,
    VITE_TEST_ONLY_FOR_PROMO: parseBuildTimeBoolean(
      import.meta.env.VITE_TEST_ONLY_FOR_PROMO,
    ),
    VITE_DEFAULT_LOCALE: import.meta.env.VITE_DEFAULT_LOCALE,
    VITE_MULTILINGUAL: parseBuildTimeBoolean(import.meta.env.VITE_MULTILINGUAL),
    VITE_SUPER_USER_SECRET: import.meta.env.VITE_SUPER_USER_SECRET,
  },
  /**
   * Skip validation if SKIP_ENV_VALIDATION is set
   */
  skipValidation: !!import.meta.env.SKIP_ENV_VALIDATION,
  /**
   * Makes it so that empty strings are treated as undefined
   */
  emptyStringAsUndefined: true,
});
